const Outer = theme => {
  return {
    backgroundImage:
      'radial-gradient(circle, #ebeaea, #f0efef, #f5f4f5, #fafafa, #ffffff)',
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  }
}

export default Outer



// WEBPACK FOOTER //
// ./src/styles/mixins/outer.js